__turbopack_context__.v({
  "section-counter": "X9w5Ca_section-counter",
  "section-counter__animation": "X9w5Ca_section-counter__animation",
  "section-counter__container": "X9w5Ca_section-counter__container",
  "section-counter__text": "X9w5Ca_section-counter__text",
});
